var map = {
	"./Icon": 17,
	"./Icon-round": 18,
	"./Icon-round.png": 18,
	"./Icon.png": 17,
	"./IconKO": 19,
	"./IconKO.png": 19,
	"./PWebText": 20,
	"./PWebText.png": 20,
	"./PrevailV": 21,
	"./PrevailV.png": 21,
	"./new-24": 22,
	"./new-24-green": 23,
	"./new-24-green.png": 23,
	"./new-24-white": 24,
	"./new-24-white.png": 24,
	"./new-24.png": 22,
	"./new-32": 25,
	"./new-32-blue": 26,
	"./new-32-blue.png": 26,
	"./new-32-green": 27,
	"./new-32-green.png": 27,
	"./new-32-white": 28,
	"./new-32-white.png": 28,
	"./new-32.png": 25,
	"./new-48": 29,
	"./new-48-green": 30,
	"./new-48-green.png": 30,
	"./new-48-white": 31,
	"./new-48-white.png": 31,
	"./new-48.png": 29,
	"./user-icon-white": 32,
	"./user-icon-white.svg": 32,
	"./white-arrow-left": 33,
	"./white-arrow-left.svg": 33,
	"./white-arrow-right": 34,
	"./white-arrow-right.svg": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;